export function getIsEnrollmentEdge(edgeId) {
  return edgeId.includes('enrollment-');
}